import * as React from 'react';

function SvgMs(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 480"
            width={props.width || 640}
            height={props.height || 480}
            {...props}
        >
            <path fill="#006" d="M0 0h640v480H0z" />
            <g fillRule="evenodd">
                <path
                    d="M408.303 192.25h214.293l-.255 153.441c1.782 61.682-36.423 99.957-106.72 117.214-49.926-12.476-107.489-38.28-107.573-115.464l.255-155.193z"
                    fill="#fff"
                />
                <path
                    d="M44.069 22.713h169.3l-.201 120.79c1.408 48.558-28.777 78.69-84.317 92.276-39.437-9.82-84.916-30.13-84.982-90.9l.201-122.17z"
                    stroke="#000"
                    strokeWidth="1pt"
                    fill="#00a2bd"
                    transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
                />
                <path
                    d="M616.248 361.329c-7.45 56.418-50.63 81.069-100.65 94.152-44.276-11.951-91.91-31.032-101.143-93.869l201.798-.283z"
                    fill="#a53d08"
                />
            </g>
            <g stroke="#000" fillRule="evenodd">
                <path
                    strokeLinejoin="round"
                    d="M155.77 197.17c.094.094.658 9.295-4.319 14.929 4.413 1.409 7.418-.282 8.826-2.066 1.409-1.784 1.879-4.037 1.879-4.037s1.22-.751 1.408-2.441c.094-2.348-.939-2.348-1.784-2.817l.187-5.258s-5.07-3.099-6.197 1.69z"
                    strokeWidth={1.25}
                    fill="#ffc6b5"
                    transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
                />
                <path
                    d="M155.49 210.32l-1.503-1.221"
                    strokeLinecap="round"
                    strokeWidth="1pt"
                    fill="#ff9a08"
                    transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
                />
            </g>
            <path
                d="M141.64 69.393s.117 5.625-.235 6.211c-.351.586-3.554 2.07-3.554 2.07l2.734 5.82s7.695-1.093 7.734-1.093 3.321-8.711 3.321-8.711-1.719-2.89-1.289-5.898c-2.578-8.165-8.594 1.64-8.711 1.601z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth="1pt"
                fill="#ffc6b5"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                strokeLinejoin="round"
                d="M131.45 203.09s4.319 4.319 9.295 3.756c11.268-1.22 14.554-11.267 18.028-11.361s5.634 6.103 8.92 5.352c-2.817-5.164-5.821-16.619-5.352-24.694.47-8.075.47-42.065.47-42.065s-5.634-17.558-8.263-20.469c2.629-2.817 4.413-7.793 4.319-13.239-.094-5.446 0-11.455 0-11.455s1.314-1.502 1.221-5.727c-.094-4.226-7.136-10.328-8.075-10.047-.939.281-9.765 7.887-10.516 9.67-.752 1.785-1.784-6.478-.094-7.23 1.69-.75-3.944-1.22-7.512 3.005-3.568 4.226-2.535 124.69-2.441 124.5z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth={1.25}
                fill="#005121"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M467.518 224.122l39.97.144-.286-18.531 14.562.144.142 18.387h39.828l.142 14.365-39.97.144-.32 169.41-14.202.09-.182-169.641-39.693.143.009-14.652z"
                fillRule="evenodd"
            />
            <path
                d="M122.03 81.959s-2.258-.398-3.984.133 2.656-19.586 2.656-21.246c1.527-.73 9.162-2.125 8.963-7.503-.531-3.253-11.818.2-11.619 4.316-.73 2.058-8.099 23.038-6.639 29.943 2.589 2.058 7.37 1.66 10.623 1.129v-6.772z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth="1pt"
                fill="#ffc6b5"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M124.22 53.211s-.664 3.718 2.722 4.25"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth={0.625}
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M129.2 53.144c-.133.066-4.382 2.722-4.382 2.722m4.122-1.062l-2.988 2.191m1.858-4.647l-3.32 1.992"
                stroke="#000"
                strokeWidth={0.375}
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M95.49 163.56l30.14 31.267c10.422-11.455 3.193-54.272-10.515-62.158-1.643 5.07-4.437 11.149-7.407 13.109-6.534 4.453-22.546 9.659-17.194 12.993 1.22-1.69 4.413-3.286 5.915.47 1.784 5.915-6.666 6.291-6.666 6.291s-5.352-.658-6.291-6.104c-.939-5.445 7.972-10.417 8.732-10.797.751-.282 12.394-3.38 14.366-13.709 2.441-10.141 4.976-8.638 5.446-8.826 15.21 1.502 25.163 28.732 25.727 47.886.563 19.154-7.793 31.83-9.296 32.675-1.502.845-36.243-41.219-36.243-41.219l3.286-1.878z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth="1pt"
                fill="#ff9a08"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M117.46 134.45l.187 56.43m-3.567-55.4l.187 51.267M110.42 142.9l.187 40.75m-3.187-37.84l.188 33.709m-3.388-32.199v28.45m-3.47-26.2v22.534m-3.006-20.754v17.276"
                stroke="#000"
                strokeWidth="1pt"
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M95.021 167.13l31.079 35.58m1.5-58.02s14.085 30.798 1.033 56.149M91.359 160.65s1.033-2.723 2.347-1.596m-4.788-6.294s-5.634 4.976-2.535 8.169"
                stroke="#ffdf00"
                strokeLinecap="round"
                strokeWidth={1.25}
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M141.03 82.999s.47 4.32-.469 7.605 3.568 12.394 1.877 14.272m.472 8.824l11.831-.094"
                stroke="#000"
                strokeWidth="1pt"
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M138.59 118.49c.094.187 1.408 6.197 1.032 10.328m2.818-8.168c-.375 1.221-5.258 15.117-5.07 15.68m7.98-21.97c.094.282-.375 8.826-1.69 10.047m7.7-10.707s7.7 17.84 7.606 24.882 2.629 21.314.845 27.605M153.8 138.4s-.564 13.239-6.103 18.403c-5.54 5.165 13.239 19.906 13.239 19.906"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="1pt"
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M153.61 175.86s2.066 18.215 5.54 19.53m-22.53-50.05c.094.188-1.878 12.3-.282 14.272 1.597 1.972 14.836 20.469 14.272 39.624m-3.76-5.726s-.376 11.549-11.08 12.488m7.89-20.088s3.193 12.018-7.699 19.624"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth={1.25}
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M147.88 156.89s12.3 12.77 12.864 18.404m-9.294-61.314s2.16 9.107 1.315 10.704"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="1pt"
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M113.51 132.69s-1.317-2.305-1.152-4.857-.412-6.502 7.82-9.713c5.021-5.103 10.618-8.149 13.663-9.712 4.445-2.881 7.327-2.223 9.96-3.211 1.729-1.975 1.646-6.338 3.457-10.206 1.811-3.869 5.021-11.853 8.478-10.618 3.458 1.235.741 11.606-.576 15.228s-2.469 7.408-4.774 9.63c-2.305 2.223-12.758 6.256-14.816 6.997s-11.441 2.88-13.828 6.174c-2.388 3.292-2.223 8.149-8.232 10.289z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth="1pt"
                fill="#ffc6b5"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M112.85 125.78c.247-.082 4.115-1.317 5.926 2.141"
                stroke="#000"
                strokeWidth="1pt"
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                strokeLinejoin="round"
                d="M141.91 55.2s-1.74 2.837-2.222 4.561c-.374 1.29-1.58-.087-2.218 2.708l1.035.181c-.412.823-.546 2.214-.628 2.543-.083.33-.662 1.834-.576 2.964.046.583 1.152 3.128 10.124-.741 8.972-3.869-2.881-14.85-5.515-12.216z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth={1.25}
                fill="#ffc6b5"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                strokeLinejoin="round"
                d="M140.9 55.563c.921-.494 7.457-1.07 6.368 11.688 1.257-.165 2.011-.33 2.764.905.754 1.235.671 2.717 2.011 2.717 1.341 0 1.509-.247 1.844-1.235.334-.988 5.53 1.152 6.869-3.457-.232-.897-3.183-2.305-3.519-3.951.755-2.305-.335-9.795-9.885-10.207-4.944-.082-5.948 1.975-6.452 3.54z"
                fillRule="evenodd"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth={1.261}
                fill="#c59200"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M140.42 58.115c.083.082 2.964.905 3.293 2.305"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="1pt"
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M531.733 244.091c0 .526-.402.951-.898.951s-.897-.425-.897-.95.401-.951.897-.951.898.425.898.95z"
                fillRule="evenodd"
            />
            <path
                strokeLinejoin="round"
                d="M154.38 61.542s-1.055 5.078 3.594 7.07m-7.034-6.445s1.722.078 1.722 1.68c0 1.601-1.414 1.796-1.296 3.086.117 1.289 2.425 1.718 2.503 2.812M143.4 52.792c.078 0 8.243.938 7.774 2.969-.469 2.031-1.758 1.21-1.719 2.968s3.281.704 3.281.704.196-1.485 1.563-1.368.742 1.68 2.617 1.64"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth={1.25}
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M138.41 65.458l1.936-.064"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth={1.25}
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <path
                d="M143.45 73.696s.72 3.36-2 3.04"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="1pt"
                fill="none"
                transform="matrix(1.2096 0 0 1.2172 359.74 169.23)"
            />
            <g strokeWidth="1pt">
                <path
                    fill="#fff"
                    d="M0 .063v28.44l343.648 225.93h43.256v-28.438L43.256.064H0zm386.904 0v28.439L43.256 254.433H0v-28.439L343.648.063h43.256z"
                />
                <path fill="#fff" d="M161.21.063v254.37h64.484V.063H161.21zM0 84.853v84.79h386.904v-84.79H0z" />
                <path
                    fill="#c00"
                    d="M0 101.811v50.874h386.904v-50.874H0zM174.107.063v254.37h38.69V.063h-38.69zM0 254.433l128.968-84.79h28.837l-128.968 84.79H0zM0 .063l128.968 84.79h-28.837L0 19.023V.063zm229.099 84.79L358.067.063h28.837l-128.968 84.79h-28.837zm157.805 169.58l-128.968-84.79h28.837l100.131 65.831v18.959z"
                />
            </g>
        </svg>
    );
}

export default SvgMs;
